{
  "id": "campaign-107",
  "name": "Formal Parterre",
  "seed": "campaign:107",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......ACCA......",
    "..B....CC,...B.~",
    "....t,,CC,,t..~~",
    ".....,.CC,.....~",
    "..T.T.TCCT.T.T..",
    ".......CC.......",
    "ww+wwww++wwww+ww",
    ".......CC.......",
    ".t..t.CCCC.t..t.",
    "CCCCCCCOOCCCCCCC",
    "....t.CCCC.t....",
    ".....x.CC.......",
    "..%%...CC...%%..",
    ".,.%..hCCh..%..x",
    "..,.............",
    "S......x........"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 4,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 12,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 12
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 7,
      "y": 6
    },
    {
      "kind": "gas",
      "x": 10,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 14,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 15
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "hills": [
    {
      "x": 2,
      "y": 1,
      "w": 3,
      "h": 3
    },
    {
      "x": 11,
      "y": 1,
      "w": 3,
      "h": 3
    }
  ],
  "generatorVersion": 3,
  "level": 107,
  "biome": "estate",
  "par": {
    "reel": 7324,
    "push": 6128,
    "selfPropelled": 5856,
    "tractor": 4639,
    "zeroTurn": 4074,
    "fairway": 3244
  },
  "goldTime": {
    "reel": 7324,
    "push": 6128,
    "selfPropelled": 5856,
    "tractor": 4639,
    "zeroTurn": 4060,
    "fairway": 3113
  },
  "routeTries": {
    "par": {
      "reel": 18,
      "push": 10,
      "selfPropelled": 0,
      "tractor": 15,
      "zeroTurn": 17,
      "fairway": 7
    },
    "gold": {
      "reel": 18,
      "push": 10,
      "selfPropelled": 0,
      "tractor": 15,
      "zeroTurn": 33,
      "fairway": 42
    }
  }
}
